import {
  Inflector,
  pluralize,
  singularize
} from "./lib/system";

export default Inflector;

export {
  pluralize,
  singularize
};
